<template>
  <v-form ref="formContato" lazy-validation>
    <v-layout row wrap>
      <v-flex md3 sm12 v-if="showCpf">
        <v-text-field
          class="form-input-box"
          :label="'CPF ' + (labelComplementar || '')"
          v-model="representante.cpf"
          :rules="[rules.obrigatorio, rules.cpfInvalido]"
          :readonly="readonly"
          v-mask="'###.###.###-##'"
          placeholder=" "
        ></v-text-field>
      </v-flex>

      <v-flex
        sm12
        :class="
          templateUser
            ? 'md4'
            : showCpf
            ? showSusep
              ? 'md6'
              : 'md9'
            : showTelefone
            ? 'md12'
            : 'md6'
        "
      >
        <v-text-field
          class="form-input-box"
          :label="'Nome ' + (labelComplementar || '')"
          v-model="representante.nome"
          :rules="[rules.obrigatorio]"
          :readonly="readonly"
          placeholder=" "
        ></v-text-field>
      </v-flex>

      <v-flex md3 sm12 v-if="showSusep">
        <v-text-field
          class="form-input-box"
          :label="'Código SUSEP ' + (labelComplementar || '')"
          v-model="representante.numero_susep"
          v-mask="['############']"
          :rules="[rules.obrigatorio]"
          :readonly="readonly"
          placeholder=" "
        ></v-text-field>
      </v-flex>

      <v-flex
        sm12
        :class="
          templateUser ? 'md4' : showTelefone ? 'md9' : showCpf ? 'md12' : 'md6'
        "
        v-if="showEmail"
      >
        <v-text-field
          class="form-input-box input-email"
          :label="'E-mail ' + (labelComplementar || '')"
          v-model="representante.email"
          :rules="[rules.obrigatorio, rules.email]"
          :readonly="readonly"
          placeholder=" "
        ></v-text-field>
      </v-flex>

      <v-flex sm12 :class="templateUser ? 'md4' : 'md3'" v-if="showTelefone">
        <v-text-field
          class="form-input-box"
          :label="'Telefone ' + (labelComplementar || '')"
          v-model="representante.telefone"
          v-mask="['(##) #####-####', '(##) ####-####']"
          :rules="[rules.obrigatorio, rules.telefone]"
          :readonly="readonly"
          placeholder=" "
        ></v-text-field>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script lang="js">
import { isValidCpf } from "@/libs/utils";

export default {
  name: "ContatoComponent",
  data() {
    return {
      alert: true,
      rules: {
        obrigatorio: (v) =>
          !!v || this.disabledValidation || "Campo obrigatório",
        cpfInvalido: (v) =>
          (!!v && isValidCpf(v)) || "CPF inválido",
        email: (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail inválido",
        telefone: (v) =>
          /^(\([0-9]{2}\))\s([9]{1})?([0-9]{4})-([0-9]{4})$/.test(v) ||
          "Telefone inválido",
      },
    };
  },
  props: [
    "representante",
    "labelComplementar",
    "showCpf",
    "showEmail",
    "showSusep",
    "showTelefone",
    "templateUser",
    "readonly",
    "disabledValidation",
  ],
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// ./src/components/ContatoComponent.vue